/* unplugin-vue-components disabled */import { render } from "./member_association_m.vue?vue&type=template&id=d28656a4&scoped=true"
import script from "./member_association_m.vue?vue&type=script&lang=js"
export * from "./member_association_m.vue?vue&type=script&lang=js"

import "./member_association_m.vue?vue&type=style&index=0&id=d28656a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d28656a4"]])

export default __exports__